import React from 'react';
import ProviderBankAccountsForm from './ProviderBankAccountsForm';
import { PROVIDER_TEXT_MAX_LENGTH } from '../../utils/provider';

const noop = () => {};

const ProviderFormFields = ({
  form = {},
  onChange = noop,
  onRutChange,
  accounts = [],
  onAccountAdd = noop,
  onAccountRemove = noop,
  onAccountChange = noop,
  formatRut = (value) => value,
  disabled = false,
  showProviderTitle = true,
  providerTitle = 'Datos del proveedor',
  providerTitleClassName = 'text-lg font-semibold mb-3',
  showAccountsTitle = true,
  accountsTitle = 'Cuentas bancarias',
  accountsTitleClassName = 'text-lg font-semibold mb-3',
  containerClassName = 'space-y-6',
  gridClassName = 'grid grid-cols-1 md:grid-cols-2 gap-4',
}) => {
  const handleRutChange = onRutChange || onChange;

  return (
    <div className={containerClassName}>
      <div>
        {showProviderTitle && <h2 className={providerTitleClassName}>{providerTitle}</h2>}
        <div className={gridClassName}>
          <input
            type="text"
            name="name"
            value={form.name || ''}
            onChange={onChange}
            placeholder="Nombre"
            className="border border-gray-300 rounded p-2 w-full"
            required
            maxLength={PROVIDER_TEXT_MAX_LENGTH}
            disabled={disabled}
          />
          <input
            type="text"
            name="rut"
            value={form.rut || ''}
            onChange={handleRutChange}
            placeholder="RUT"
            className="border border-gray-300 rounded p-2 w-full"
            maxLength={PROVIDER_TEXT_MAX_LENGTH}
            disabled={disabled}
          />
          <input
            type="text"
            name="giro"
            value={form.giro || ''}
            onChange={onChange}
            placeholder="Giro"
            className="border border-gray-300 rounded p-2 w-full"
            maxLength={PROVIDER_TEXT_MAX_LENGTH}
            disabled={disabled}
          />
          <input
            type="email"
            name="email"
            value={form.email || ''}
            onChange={onChange}
            placeholder="Email"
            className="border border-gray-300 rounded p-2 w-full"
            maxLength={PROVIDER_TEXT_MAX_LENGTH}
            disabled={disabled}
          />
          <input
            type="text"
            name="phone"
            value={form.phone || ''}
            onChange={onChange}
            placeholder="Telefono"
            className="border border-gray-300 rounded p-2 w-full"
            maxLength={PROVIDER_TEXT_MAX_LENGTH}
            disabled={disabled}
          />
          <input
            type="text"
            name="address"
            value={form.address || ''}
            onChange={onChange}
            placeholder="Direccion"
            className="border border-gray-300 rounded p-2 w-full"
            maxLength={PROVIDER_TEXT_MAX_LENGTH}
            disabled={disabled}
          />
          <input
            type="text"
            name="city"
            value={form.city || ''}
            onChange={onChange}
            placeholder="Ciudad"
            className="border border-gray-300 rounded p-2 w-full"
            maxLength={PROVIDER_TEXT_MAX_LENGTH}
            disabled={disabled}
          />
        </div>
      </div>

      <div>
        {showAccountsTitle && <h2 className={accountsTitleClassName}>{accountsTitle}</h2>}
        <ProviderBankAccountsForm
          accounts={accounts}
          onAdd={onAccountAdd}
          onRemove={onAccountRemove}
          onChange={onAccountChange}
          formatRut={formatRut}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default ProviderFormFields;
